import { getCookie } from "@/lib/getCookie";
import { LOGIN_ROLES } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

type LoginRole = (typeof LOGIN_ROLES)[keyof typeof LOGIN_ROLES];

const ProtectedRoute = ({ allowedRoles }: { allowedRoles: any[] }) => {
  // Check for token
  const token = getCookie("accessToken");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  // check for roles
  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  // Flatten the nested roles array and check if any role matches allowed roles
  const userRoles = loggedInUserData?.roles?.flat() || [];
  const roleExists = userRoles.some((userRole: any) =>
    allowedRoles.includes(userRole.toString())
  );

  return roleExists ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
